import PropTypes from "prop-types";

export const DGIType = PropTypes.shape({
  version: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      attributes: PropTypes.arrayOf(PropTypes.shape({})),
      drug_chembl_id: PropTypes.string,
      drug_anti_neoplastic: PropTypes.bool,
      drug_fda_approved: PropTypes.bool,
      drug_immunotherapy: PropTypes.bool,
      drug_name_primary: PropTypes.string,
      gene_entrez: PropTypes.number,
      gene_symbol: PropTypes.string,
      id: PropTypes.string,
      interaction_type: PropTypes.arrayOf(PropTypes.string),
      disease: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          normalized_cancer: PropTypes.string,
        })
      ),
    })
  ),
});
